//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import vueSeamlessScroll from 'vue-seamless-scroll';
	import pbcFun from "../api/publicFun";
	export default {
		components: {
			vueSeamlessScroll
		},
		data() {
			return {
				listData:[],
				timer:''
			};
		},
		created(){
			this.getData()
		},
		mounted(){
			// 设置定时器前先执行一次数据获取
			this.getData()
			this.timer = setInterval(() => {
				this.getData()
			}, 60 * 1000)
		},
		beforeDestroy(){
			if(this.timer){
				clearInterval(this.timer)
				this.timer = null
			}
		},
		methods:{
      getFullYear(d) {
      // 修正firefox下year错误
      var yr = d.getYear();
      if (yr < 1000) yr += 1900;
      return yr;
    },
			async getData(){
				try {
          
      var dNow = new Date();
					const response = await this.pbcFun.axios.http('https://by.shyunhua.com/shyh1/api/QueueService.ashx?method=WindowCount&StartDate='+this.getFullYear(dNow)+'-'+(dNow.getMonth() + 1)+'-'+dNow.getDate()+'&EndDate='+this.getFullYear(dNow)+'-'+(dNow.getMonth() + 1)+'-'+dNow.getDate())
          this.listData = response.data.filter(item => item.OrgCode !== '1001')
					// const response = await this.pbcFun.axios.http('https://byapi.shyunhua.com/api/home/getBusinessLists')
					// // 验证返回数据是否为数组
					// if (Array.isArray(response)) {
					// 	this.listData = response
					// } else {
					// 	console.warn('API返回数据格式异常，期望数组格式:', response)
					// 	this.listData = []
					// }
				} catch (error) {
					console.error('获取业务列表数据失败:', error)
					// 保持原数据不变，避免界面闪烁
				}
			}
		},
		computed:{
			// 公告滚动自定义
			defaultOption() {
				return {
					step: 0.3, // 数值越大速度滚动越快
					limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					// openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
	}



// WEBPACK FOOTER //
// ./src/components/Scroll.vue